import React from 'react';

const CalendarColDivider: React.FC<CalendarColDividerProps> = ({
    gridColumn,
    gridRowStart,
    gridRowEnd,
    opacity = 1,
    color = '#ccc',
}) => {
    return (
        <div
            className="calendar-col-divider"
            style={{
                gridColumn,
                gridRowStart,
                gridRowEnd,
                opacity,
                backgroundColor: color,
            }}
        />
    );
};

interface CalendarColDividerProps {
    gridColumn: string;
    gridRowStart: string;
    gridRowEnd: string;
    opacity?: number;
    color?: string;
}

export default CalendarColDivider;
